import React from 'react';
import {
    Show,
    TextField,
    ArrayField,
    Datagrid,
    CardActions,
} from 'react-admin';
import {
    Card,
    CardContent,
    Typography
} from '@material-ui/core';

import "./styles/main.css"

const FailedPrescriptionShowTitle = ({ record }) => {
    return <span>Непогашені рецепти: {record ? `"${record.number}"` : ''}</span>;
};

const Label = (prop) => {
    return (
        <span style={labelStyle}>{prop.caption}: </span>
    );
}

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const FailedPrescriptionActions = ({ data }) => (
    <CardActions></CardActions>
);

const getAllTimeHours = (timeRange) => {
    if (timeRange.length) {
        return timeRange.map((item) => `  ${item.start} - ${item.end}`).join(";");
    } else {
        return ""
    }
}

const FailedPrescriptionShow = (props) => {
    return (
        <Show className="show-styles" {...props} title={<FailedPrescriptionShowTitle/>} actions={<FailedPrescriptionActions />}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Загальна інформація</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер"}/>
                            <TextField className="division-show-item" label="Номер" source="number"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Код"}/>
                            <TextField className="division-show-item" label="Код" source="code"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Медична програма"}/>
                            <TextField className="division-show-item" label="Медична програма" source="medicalProgramName"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Аптека"}/>
                            <TextField className="division-show-item" label="Аптека" source="employee.divisionName"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Співробітник"}/>
                            <TextField className="division-show-item" label="Співробітник" source="employee.fullName"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер чека"}/>
                            <TextField className="division-show-item" label="Номер чека" source="paymentId"/>
                        </CardContent>
                        <Card style={cardStyle}>
                            <Typography variant="h6" style={{marginBottom: '0.5em'}}>Препарати</Typography>
                            <CardContent style={rowStyle}>
                                <ArrayField label="Препарати" source="items">
                                    <Datagrid>
                                        <TextField label="Препарат" source="medicationName" />
                                        <TextField label="Кількість" source="medicationQuantity" />
                                        <TextField label="Ціна за одиницю" source="sellPrice" />
                                        <TextField label="Вартість" source="sellAmount" />
                                        <TextField label="Знижка" source="discountAmount" />
                                    </Datagrid>
                                </ArrayField>
                            </CardContent>
                        </Card>
                    </Card>
                </div>
            </div>
        </Show>
    );
};

export default FailedPrescriptionShow;
